import { Container, Navbar, Dropdown, Button } from "react-bootstrap"
import { useNavigate } from "react-router-dom";
import { GoChevronDown } from "react-icons/go";
import { MdRealEstateAgent } from "react-icons/md";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { reduxInitialState } from "../../screens/onBoarding/onBoardingTypes";
import { NAVIGATION_RESET } from "../../redux/action_constant";
import Select from 'react-select';

const Header = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const navigationData: { NavigateTo: string } = useSelector((state: reduxInitialState) => state.NavigationReducer);

    useEffect(() => {
        if (navigationData && navigationData.NavigateTo) {
            dispatch({ type: NAVIGATION_RESET, payload: '' });
            const navigateTo: any = isNaN(Number(navigationData.NavigateTo)) ? navigationData.NavigateTo : Number(navigationData.NavigateTo);
            navigate(navigateTo);
        }
    }, [navigationData]);

    const onLogout = () => {
        localStorage.clear();
        window.location.href = '/';
    };

    return (
        <>
            <header className="site-header">
                <Container fluid className='header-nav'>
                    <Navbar expand="lg">
                        <Navbar.Brand className="me-5">
                            <MdRealEstateAgent size={40} color="#1abecb" /> <span className="text-brand font-medium">Plot Management</span>
                            {/* <img src={Logo} width={186} height={30} alt='' /> */}
                        </Navbar.Brand>
                        <Navbar.Toggle aria-controls="basic-navbar-nav" />
                        {/* <div className="input-group mb-1">
                            <Select
                                className="basic-single w-100"
                                classNamePrefix="select"
                                isSearchable={true}
                                options={[]}
                                // isMulti={true}
                                onChange={(e: any) => {}}
                                value={''}
                                placeholder="Select Project"
                            />
                        </div> */}
                        <div className="d-flex align-items-center ms-auto gap-3" >
                            <Dropdown className="profile2-dd">
                                <Dropdown.Toggle>
                                    {/* {
                                        userInfoData && userInfoData?.user_info && !HelperService.isEmptyObject(userInfoData?.user_info) &&
                                        <div className='d-flex gap-2 align-items-center'>
                                            <div><img src={userInfoData?.user_info?.avtar ? userInfoData?.user_info?.avtar : avtar} width={35} height={35} className=" rounded-circle object-fit-cover" alt='' /></div>
                                            <div >
                                                <p className='font-14 mb-0 text-white font-medium'>{userInfoData?.user_info?.first_name} {userInfoData?.user_info?.last_name}</p>
                                                <p className='font-12 mb-0 text-white text-secondary'>{userInfoData?.user_info?.email}</p>

                                            </div>
                                        </div>
                                    } */}
                                    {/* <div className='d-flex gap-2'>
                                        <div><img src={avtar} width={35} height={35} className=" rounded-circle object-fit-cover" alt='' /></div>
                                        <div >
                                            <p className='font-14 mb-0 text-dark font-medium'>Randy Wonana</p>
                                            <p className='font-12 mb-0 text-secondary'>randywonana123@gmail.com</p>
                                        </div>
                                    </div> */}
                                    <GoChevronDown size={16} className='icon' />
                                </Dropdown.Toggle>
                                <Dropdown.Menu align="end">
                                    {/* <Link to="/profile" className="dropdown-item">My Profile</Link> */}

                                    <Button className=" dropdown-item" onClick={() => onLogout()}>Logout</Button>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    </Navbar>
                </Container>
            </header>

        </>
    )
}
export default Header;